import React, { useRef, useState, useContext } from "react";
import PropTypes from "prop-types";
import Box from "@mui/material/Box";
import Tools from "./JNSTools";
import DashboardPanelHeader from "./DashboardPanelHeader";
import {
  ChartComponent,
  SeriesCollectionDirective,
  SeriesDirective,
  Inject,
  Legend,
  Category,
  Tooltip,
  DataLabel,
  StackingBarSeries,
  ChartAnnotation,
} from "@syncfusion/ej2-react-charts";
import { CredsContext, HelpModeContext } from "./Contexts";
import "./styles/DashboardProjectMetrics.css";

function DashboardProjectMetricsBar(props) {
  const projectObject = useRef(
    JSON.parse(sessionStorage.getItem("projectObject")),
  );
  const creds = useContext(CredsContext).creds;
  const helpMode = useContext(HelpModeContext).mode;
  const [metricState, setMetricState] = useState(props.metric);

  const showBilling =
    projectObject.current.oada_project_show_billing__c == 1 ? true : false;

  const metrics = Tools.calculateProjectMetrics(projectObject.current, creds);

  const moneyConfig = new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
    maximumFractionDigits: 0,
  });

  const axisMaximum =
    metricState == "money"
      ? metrics.budgetMoney > metrics.eacMoney
        ? metrics.budgetMoney * 1.05
        : metrics.eacMoney * 1.05
      : metrics.budgetHours > metrics.eacHours
        ? metrics.budgetHours * 1.05
        : metrics.estimateAtCompletion * 1.05; // 1.05 is a buffer for cylinder end
  const primaryxAxis = { valueType: "Category", title: null };
  const primaryyAxis = {
    title: null,
    minimum: 0,
    maximum: axisMaximum,
    edgeLabelPlacement: "Shift",
    labelFormat: "{value}",
  };

  const yNameActual = metricState == "money" ? "actualMoney" : "actualHours";
  const yNameETC = metricState == "money" ? "etcMoney" : "etcHours";
  const yNameBudget = metricState == "money" ? "budgetMoney" : "budgetHours";
  const chartTitle = metricState == "money" ? "Money Metrics" : "Hours Metrics";
  //const titleStyle = { position: "Custom", x: axisMaximum / 2 - 20, y: 10 };
  const actualEtcData = [
    {
      title: metricState == "money" ? "Money" : "Hours",
      actualHours: metrics.actualHours,
      etcHours: metrics.estimateToCompletion,
      actualMoney: metrics.actualMoney,
      etcMoney: metrics.etcMoney,
    },
  ];
  const budgetData = [
    {
      title: "Budget",
      budgetHours: metrics.budgetHours,
      budgetMoney: metrics.budgetMoney,
    },
  ];

  const tooltip = { enable: true, location: { x: 60, y: 60 } };

  const handleClick = () => {
    if (metricState == "money") {
      setMetricState("hours");
    } else if (showBilling) {
      setMetricState("money");
    }
  };
  return (
    <>
      <Box
        height="12%"
        className="dashTableTitleBar"
        id="__dashboardProjectMetricsBar"
        sx={{ cursor: helpMode ? "help" : "default" }}
      >
        <DashboardPanelHeader
          panelLocked={props.panelLocked}
          title="Actual, Budget, and ETC"
          removePanel={props.removePanel}
          panelId={props.panelId}
          //headerComponent={addLinkComponent}
        />
      </Box>
      <Box
        sx={{
          overflow: "auto",
          verticalAlign: "middle",
          border: "solid 2px",
          padding: "0px 4px 4px 4px",
          borderRadius: "0px 0px 6px 6px",
          backgroundColor: "white",
        }}
        height="85%"
      >
        <ChartComponent
          id="charts"
          primaryXAxis={primaryxAxis}
          primaryYAxis={primaryyAxis}
          //title={chartTitle}
          //height="200px"
          legendSettings={{ visible: true }}
          tooltip={tooltip}
          //titleStyle={titleStyle}
          enableAnimation={false}
          onClick={handleClick}
        >
          <Inject
            services={[
              StackingBarSeries,
              Legend,
              Tooltip,
              DataLabel,
              Category,
              ChartAnnotation,
            ]}
          />

          <SeriesCollectionDirective>
            <SeriesDirective
              dataSource={actualEtcData}
              animation={{ enable: false }}
              xName="title"
              yName={yNameActual}
              name="Actual"
              type="StackingBar"
              fill="#1543A0"
              columnFacet="Cylinder"
            ></SeriesDirective>
            <SeriesDirective
              dataSource={actualEtcData}
              animation={{ enable: false }}
              xName="title"
              yName={yNameETC}
              name="ETC"
              type="StackingBar"
              fill="lightblue"
              columnFacet="Cylinder"
            ></SeriesDirective>
            <SeriesDirective
              dataSource={budgetData}
              animation={{ enable: false }}
              xName="title"
              yName={yNameBudget}
              name="Budget"
              type="StackingBar"
              fill="#004800"
              columnFacet="Cylinder"
            ></SeriesDirective>
          </SeriesCollectionDirective>
        </ChartComponent>
      </Box>
    </>
  );
}

export default DashboardProjectMetricsBar;

DashboardProjectMetricsBar.propTypes = {
  metric: PropTypes.string,
  projectObject: PropTypes.object,
  panelLocked: PropTypes.bool,
  removePanel: PropTypes.func,
  panelId: PropTypes.number,
};
